module.exports = BootstrapVue;